import React from 'react'
import { H2, H3 } from '../headings/index'
import { EtapasWrapper, EtapasGrid, Etapa, EtapaImageWrapper } from './style'
import globals from '../globals'
import LogoSeguroResidencial from '../../images/logos/logo-invertida-nova.png'
import Circle from '../../images/circle.svg'
import PictoEtapaUm from '../../images/etapa-1.svg'
import PictoEtapaDois from '../../images/etapa-2.svg'
import PictoEtapaTres from '../../images/etapa-3.svg'
import PictoEtapaQuatro from '../../images/etapa-4.svg'
import PictoEtapaCinco from '../../images/etapa-5.svg'

const EtapaItem = props => {
  const { number, title, children, illustration } = props

  return (
    <Etapa>
      <div>
        <EtapaImageWrapper>
          <img src={Circle} className="circle" alt="" width="96" height="90" />
          <img className="illustration" src={illustration} alt={title} />
        </EtapaImageWrapper>
      </div>
      <div className="title-wrapper">
        <span>#{number}</span>
        <H3 weight={800}>{title}</H3>
        <div>{children}</div>
      </div>
    </Etapa>
  )
}

const ComoContratar = props => {

  return (
    <EtapasWrapper id="como-contratar">
      <H2 weight={800} fontStyle="italic">Veja Como é Fácil Contratar</H2>
      <p>Este é um serviço de uso exclusivo para imobiliárias e corretores de imóveis. Qualquer pessoa física ou empresa interessada em contratar o serviço, deve procurar uma imobiliária parceira da CredPago para contratar o Seguro Residencial</p>
      <EtapasGrid>

        <EtapaItem 
          number={1}
          illustration={PictoEtapaUm}
          title="Cadastro">
          <p>A imobiliária deve estar cadastrada na plataforma CredPago. Para cadastrar, <br /><a href={globals.LINK_CADASTRO}>Clique Aqui</a></p>
        </EtapaItem>

        <EtapaItem 
          number={2}
          illustration={PictoEtapaDois}
          title="Imobiliária parceira">
          <p>O Inquilino procura uma imobiliária e aluga com CredPago</p>
        </EtapaItem>

        <EtapaItem 
          number={3}
          illustration={PictoEtapaTres}
          title="Incluir Seguro">
          <p>A imobiliária inclui na contratação o Seguro Residencial CredPago</p>
        </EtapaItem>

        <EtapaItem 
          number={4}
          illustration={PictoEtapaQuatro}
          title="Aceite da proposta">
          <p>O Inquilino aceita os termos e paga as taxas</p>
        </EtapaItem>

        <EtapaItem 
          number={5}
          illustration={PictoEtapaCinco}
          title="Imóvel Segurado">
          <p>Pronto! O imóvel está alugado e devidamente segurado</p>
        </EtapaItem>

        <div className="logo-seguro-wrapper">
          <img 
            className="logo-seguro"
            src={LogoSeguroResidencial} 
            alt="Seguro Residencial CredPago" 
            width="265"
            />
        </div>

      </EtapasGrid>
    </EtapasWrapper>
  )
}

export default ComoContratar